import React from 'react';

import { makeStyles } from 'react-scale/components/design-system';
import { buildURL, remotasksURL } from '@scale/frontend-lib/urls';
import { OUTLIER_FRONTEND_URL } from 'react-scale/lib/constants';

const RemotasksExternalLink: React.FC<{
  path: string;
  tooltip?: string;
  query?: string | object;
  disabled?: boolean;
  isOutlier?: boolean;
  confirm?: string;
  children?: React.ReactNode;
}> = ({ children, ...props }) => {
  const {
    path,
    query,
    isOutlier,
    tooltip = "will be opened in remotasks.com, you'll need to be logged in",
    disabled = false,
    confirm,
  } = props;

  const classes = useStyles();
  const linkURL = React.useMemo(() => {
    return isOutlier ? buildURL(OUTLIER_FRONTEND_URL, path, query) : remotasksURL(path, query);
  }, [isOutlier, path, query]);

  return (
    <a
      href={linkURL}
      target="_blank"
      rel="noopener noreferrer"
      data-tip={tooltip}
      data-for="remotasks-external-link"
      className={disabled ? classes.disabled : ''}
      onClick={e => {
        if (!confirm) return true;
        if (window.confirm(confirm)) {
          return true;
        } else {
          e.stopPropagation();
        }
        e.preventDefault();
      }}
    >
      {children}
    </a>
  );
};

const useStyles = makeStyles(() => {
  return {
    disabled: {
      pointerEvents: 'none',
      cursor: 'default',
      opacity: 0.5,
    },
  };
});

export default RemotasksExternalLink;
